import api from '@pray/shared/utils/api';

export async function createGivingAccount({ artistId = '', country } = {}) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!country) throw new Error('Country is required');

  const url = `/web/studio/artists/${artistId}/giving-accounts`;
  const response = await api.executePostRequest(url, { country });

  return response.data;
}
